import { render } from "./Familias.vue?vue&type=template&id=f48fd6ee&ts=true"
import script from "./Familias.vue?vue&type=script&lang=ts"
export * from "./Familias.vue?vue&type=script&lang=ts"

import "./Familias.vue?vue&type=style&index=0&id=f48fd6ee&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__